import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { textTruncate } from '@/helpers/text_truncate';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ProductListing = class ProductListing extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.selectedProducts = [
            {
                name: 'Sample Name',
                price: '1500',
                featuredGalleryPhoto: {
                    galleryBlob: {
                        originalUrl: 'https://erp-staging.chatgenie.ph//rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNk52QXc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--3e8d65f8cf9b7c25a990156311cd2f5c785d00d7/men4.jpg',
                    },
                },
                ref_link: 'https://m.me/158355160701945?ref=CG_MINI_APP_FB_SHOP:QTg1UzdNRTVJNHd5eGJ2UVU1YzB5aHJ3eVdBcTZKU1BscWthK21lOHcvZVRLSVVPQWRLSFZpNjc1cmM2Ci9ER3oK:TVNYQnAzTXQ5NmZWNlpKbmVCa1h3dWtSQ0dpbnV1MHVKSDM2QnhvelhVb2pFVXBTS3czVktrQVVueG1EClBVd2ZHemtSeHQvTmFhZU0zc0JGanVyaTQwL25NMnhWbDNIQlpISDllOWZ6dGFVPQo=',
            },
        ];
    }
    productPhoto(product) {
        return product.featuredPhotoUrl || product.featuredGalleryPhoto?.galleryBlob.originalUrl;
    }
    truncatedProductName(name) {
        return textTruncate(name || '', 15);
    }
    getUuidId(uuid) {
        return `#${uuid}`;
    }
};
__decorate([
    Prop({ type: String, required: false })
], ProductListing.prototype, "uuid", void 0);
__decorate([
    Prop({ type: Array, required: true })
], ProductListing.prototype, "products", void 0);
__decorate([
    Prop({ type: Boolean, required: false })
], ProductListing.prototype, "generated", void 0);
ProductListing = __decorate([
    Component({
        components: {},
        apollo: {},
    })
], ProductListing);
export default ProductListing;
